import { Fragment } from "react";
import classes from "./StoreItem.module.css";
import { Link } from "react-router-dom";
import Zoom from "react-reveal/Zoom";

const StoreItem = (props) => {
  const product = props.product;
  const slug = product.slug;
  const price = new Intl.NumberFormat().format(product.prevPrice);
  const promoPrice = new Intl.NumberFormat().format(product.price);

  return (
    <Fragment>
      <li key={product.id}>
        {true && (
          <div className={classes.promo}>
            <span>-{product.discount}%</span>
          </div>
        )}
        {
          <Zoom bottom>
            <div className={classes.image}>
              <img alt={product.name} src={product.image} />
            </div>
          </Zoom>
        }
        {<p>{product.name}</p>}
        {<p className={classes.price}>N{promoPrice}</p>}
        {<s className={classes.slide}>N{price}</s>}
        <button>
          <Link to={`/store/${slug}`}>View Details</Link>
        </button>
      </li>
    </Fragment>
  );
};

export default StoreItem;
